import React from 'react';
//children
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../common/Modal';


export const IgnoreCaseModal = (props) => {
  //const caseIds = Object.keys(props.cases);
  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.pageJson.par.notification_popText.message3)} />
      <ModalBody>
          <p>{props.isIgnoreCase === true ? props.translations(props.pageJson.par.notification_popText.message1) : props.translations(props.pageJson.par.notification_popText.message2)}</p>
          <p>{props.isIgnoreCase === true ? props.translations(props.pageJson.par.notification_popText.message4) : props.translations(props.pageJson.par.notification_popText.message5)}</p>
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default return-btn" onClick={props.toggleDialog}>{props.translations(props.pageJson.par.button_no.name)}</button>
        <button className="gdocs-btn-primary" onClick={props.submitRequest}>{props.translations(props.pageJson.par.button_yes.name)}</button>
      </ModalFooter>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/components/ViewEntityProfile/Modals/index.js